/* @flow */

export const replace = (values: string[], i18nString: string) => values.reduce((pre, cur) => pre.replace('##', cur), i18nString);
export const getLabel = (label: string, i18n:Object = {}, fallbackStr?: string): string => (
  i18n[label] || (fallbackStr || label)
);

export const getLabelWithDefaultStr = (url: string, locale: Object = {}, defaultStr: string): string => {
  const i18nStr = getLabel(url, locale, defaultStr);
  // NOTE:
  // If i18nStr === ' ', it means there are no translations available for that locale
  // from our i18n platform. (It could be thought of as a legacy bug.)
  return i18nStr !== ' ' ? i18nStr : defaultStr;
};

export const getModuleLocaleDataKey = (module: string = '', locale: string): string => `${locale}${module.replace(/^\w/, c => c.toUpperCase())}`;

export const geti18nUrl = (
  url: string,
  locale: string = 'en',
): string => {
  const i18nFmt = '%locale';
  if (url.indexOf(i18nFmt) === -1) {
    return url;
  }

  let i18nUrl = url.replace('%locale', locale);

  // NOTE: Binance Academy does not have "/en/" in url for locale=en
  if (i18nUrl.match(/binance\.vision/)) {
    i18nUrl = i18nUrl.replace('/en/', '/');
  }

  return i18nUrl;
};
